var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.86,
    height: 12.573,
    viewBox: "0 0 18.86 12.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14730",
    "data-name": "Path 14730",
    d: "M9.43,5C3.823,5,.2,10.791.136,10.9a.627.627,0,0,0-.034.733l0,0c.011.022,3.051,5.94,9.326,5.94,6.248,0,9.284-5.86,9.321-5.932l.007-.012a.628.628,0,0,0-.033-.732h0C18.658,10.791,15.037,5,9.43,5Zm0,1.886a4.4,4.4,0,1,1-4.4,4.4A4.4,4.4,0,0,1,9.43,6.886Zm0,2.515a1.886,1.886,0,1,0,1.886,1.886A1.886,1.886,0,0,0,9.43,9.4Z",
    transform: "translate(0 -5)",
    fill: "#129ac4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee);
export default __webpack_public_path__ + "static/media/see.1e5e40dab485f2103dde936da15e1558.svg";
export { ForwardRef as ReactComponent };